import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from '../Input';
import { Button } from '../Button';
import { Icon } from '../Icon';
import CustomLink from '../CustomLink';
import { PRIVACY_POLICY_LINK } from '../../shared/links';
import { useSendResults } from '../../shared/use-send-results';
import styles from './EmailSlideV7.css';

function EmailSlideV7({
    setEmail,
    onContinue,
    results,
    legalLinks = { privacyPolicy: PRIVACY_POLICY_LINK }
}) {
    const emailRef = useRef(null);
    const afterSuccessfulSendResults = callback => {
        document.getElementById('root').scrollIntoView({ block: 'start', behavior: 'smooth' });

        callback(); /* eslint-disable-line */
        onContinue();
    };

    const { fields, changeField, isPending, submitForm, errors } = useSendResults({ saveEmail: setEmail, afterCallback: afterSuccessfulSendResults, initialPrelander: results?.version });
    const isDidYouMean = Boolean(errors.form?.didYouMean);

    useEffect(() => {
        setTimeout(() => {
            emailRef.current?.focus();
        }, 50);
    }, []);

    return (
        <form
            className={styles.root}
            onSubmit={submitForm}
        >
            <div className={styles.head}>
                <h1 className={styles.title}>Plan for <span className={styles.titleAccent}>Your Digital Book</span> is ready!</h1>
                <p className={styles.description}>Enter your email to save it.</p>
            </div>
            <Input
                value={fields.email}
                name='email'
                onChange={changeField}
                className={styles.input}
                placeholder='Your email address'
                errorText={errors.email || (!isDidYouMean && errors.form?.message)}
                disabled={isPending}
                inputProps={{ autoComplete: 'email', type: 'email', inputMode: 'email' }}
                emailDomainSuggestions={{
                    list: ['gmail.com', 'yahoo.com', 'icloud.com', 'hotmail.com', 'aol.com', 'outlook.com', 'comcast.net', 'att.net', 'live.com', 'mail.com', 'msn.com']
                }}
                inputRef={emailRef}
                didYouMean={errors.form?.didYouMean}
            />
            <div className={styles.coupon}>
                <Icon name='present' className={styles.couponIcon} />
                <p className={styles.couponText}>
                    {'You’re eligible to redeem the coupon code '}
                    <strong>welcome2026</strong>
                    {' in the next steps and '}
                    <strong>save up to 42%</strong>
                    {' on your order.'}
                </p>
            </div>
            <div className={styles.agreementBlock}>
                <Icon name='lockSolid' />
                <span>
                    {'We’ll use your email to save your plan and send you updates about Boundly. You can unsubscribe at any time. See our '}
                    <CustomLink
                        to={legalLinks.privacyPolicy}
                        target='_blank'
                    >
                        Privacy&nbsp;Policy
                    </CustomLink>
                    .
                </span>
            </div>
            <div className={styles.footer}>
                <div className={styles.footerWrapper}>
                    <Button
                        type='pine'
                        label='Continue'
                        isLoading={isPending}
                        inSlide
                        buttonProps={{ type: 'submit' }}
                    />
                </div>
            </div>
        </form>
    );
}

EmailSlideV7.propTypes = {
    setEmail: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    results: PropTypes.shape({ version: PropTypes.string }),
    legalLinks: PropTypes.object
};

export {
    EmailSlideV7
};
